export const MAX_PIN_GROUPS = 25;

export const MAX_DESCRIPTION_LENGTH = 100;
